"use client";

import * as React from "react";

export const UI_LOCALE_STORAGE_KEY = "ui_locale";
export const UI_LOCALE_EVENT = "ui-locale-change";

export function useUiLocale() {
  const [locale, setLocale] = React.useState<string>("de-CH");

  React.useEffect(() => {
    try {
      const saved = localStorage.getItem(UI_LOCALE_STORAGE_KEY);
      if (saved) setLocale(saved);
    } catch {
      // Ignore storage failures.
    }
    let alive = true;
    (async () => {
      try {
        const res = await fetch("/api/locale", { cache: "no-store" });
        const json = await res.json();
        if (!alive || !res.ok || !json.ok) return;
        const next = String(json.effectiveLocale || "de-CH");
        setLocale(next);
        try {
          localStorage.setItem(UI_LOCALE_STORAGE_KEY, next);
        } catch {
          // Ignore storage failures.
        }
      } catch {
        // Keep current value.
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  React.useEffect(() => {
    function onLocaleChange(evt: Event) {
      const next = (evt as CustomEvent<{ locale?: string }>).detail?.locale;
      if (next) setLocale(next);
    }
    window.addEventListener(UI_LOCALE_EVENT, onLocaleChange as EventListener);
    return () => window.removeEventListener(UI_LOCALE_EVENT, onLocaleChange as EventListener);
  }, []);

  return locale;
}

